import { Button, Collapse, Flex, Group, Text, useMantineTheme } from '@mantine/core';
import { PlusSquare } from '@phosphor-icons/react';
import classes from '../ActivityDetails.module.scss';
import { ClassesType } from 'types';
import { useState } from 'react';

interface IAddonsAdvertisement {
  selectedClass: ClassesType | null;
  heading: string;
}

const AddonsAdvertisement: React.FC<IAddonsAdvertisement> = ({ selectedClass, heading }) => {
  const theme = useMantineTheme();
  const [showMore, setShowMore] = useState(false);
  const ticketModal = heading === 'Available during checkout:';

  return (
    <>
      <Flex gap="xs">
        <PlusSquare size={22} color={theme.colors.blue[8]} />
        <Text
          fw={600}
          size={ticketModal ? '16px' : '14px'}
          c={theme.colors.blue[8]}
          lh={'18px'}
          mb="xs"
        >
          {heading}
        </Text>
      </Flex>
      <Group ml="xl" gap="xs">
        {selectedClass?.addons.slice(0, 6).map((addon) => (
          <Text key={addon.name} className={classes.addOnBadge}>
            {addon.name}
          </Text>
        ))}
      </Group>
      {selectedClass?.addons && selectedClass.addons.length > 6 && (
        <>
          <Flex ml="xl" gap="xs" mt="xs" mb={showMore ? 'xs' : 0}>
            <Collapse in={showMore}>
              <Group gap="xs">
                {selectedClass?.addons.slice(6).map((addon) => (
                  <Text key={addon.name} className={classes.addOnBadge}>
                    {addon.name}
                  </Text>
                ))}
              </Group>
            </Collapse>
          </Flex>
          <Button
            variant="transparent"
            className={classes.viewMoreLessButton}
            onClick={() => setShowMore((prev) => !prev)}
          >
            {showMore ? 'View Less' : 'View More'}
          </Button>
        </>
      )}
    </>
  );
};

export default AddonsAdvertisement;
